import React from 'react';
import UIStore from '../stores/UIStore';
import UserStore from '../stores/UserStore';

const uiStore = new UIStore();
const userStore = new UserStore();

const storesContext = React.createContext({
  UIStore: uiStore,
  UserStore: userStore,
});

export default {
  storesContext,
};
